export default "__VITE_ASSET__fe7c0fde__"